import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getTransportes,
  deleteTransporte,
  getTransporteById,
} from "../helpers/rutaTransportes";
import ModalTransporte from "./ModalTransporte";

const COLS = { acciones: 90, nro: 80, transporte: 240, domicilio: 200, telefono: 140, cuit: 140, email: 220, localidad: 180 };
const cellTruncate = { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" };

const TableTransportes = () => {
  const [state, setState] = useState({ transportes: [], loading: true, error: "" });
  const [transporte, setTransporte] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => { consultaTransportes(); }, []);

  const consultaTransportes = async () => {
    try {
      const datos = await getTransportes(); // ← ya es array normalizado
      console.log("📦 Transportes:", datos);
      const lista = Array.isArray(datos)
        ? datos
        : (Array.isArray(datos?.transportes) ? datos.transportes : []);
      setState({ transportes: lista, loading: false, error: "" });
    } catch (e) {
      console.error("❌ getTransportes:", e);
      setState(s => ({ ...s, loading: false, error: e?.message || "Error al cargar transportes" }));
    }
  };

  const handleClose = () => { setShow(false); consultaTransportes(); };

  const modificaTransporte = async (id) => {
    try {
      const resp = await getTransporteById(id);
      if (resp?.ok) {
        setTransporte(resp.transporte);
        setShow(true);
      } else {
        console.error("❌ Error al obtener transporte:", resp?.error || resp);
      }
    } catch (e) {
      console.error("❌ getTransporteById:", e);
    }
  };

  const eliminarTransporte = async (id) => {
    if (!window.confirm("¿Está seguro que desea borrar el transporte?")) return;
    try {
      await deleteTransporte(id);
      consultaTransportes();
    } catch (e) {
      console.error("❌ deleteTransporte:", e);
    }
  };

  if (state.loading) return <div className="p-3">Cargando transportes…</div>;
  if (state.error)   return <div className="p-3 text-danger">{state.error}</div>;

  const rows = state.transportes
    .filter(t => t?.activo ?? true)
    .sort((a,b) => (a.transporte || "").localeCompare(b.transporte || "", "es", { sensitivity: "base" }));

  return (
    <div className="table-container">
      <div className="col-12 mt-4" />
      <div>
        <Table striped bordered hover style={{ tableLayout: "fixed", width: "100%" }}>
          <thead>
            <tr className="header">
              <th style={{ width: COLS.acciones }}>Acciones</th>
              <th style={{ width: COLS.nro }}>Nro</th>
              <th style={{ width: COLS.transporte }}>Transporte</th>
              <th style={{ width: COLS.domicilio }}>Domicilio</th>
              <th style={{ width: COLS.telefono }}>Teléfono</th>
              <th style={{ width: COLS.cuit }}>CUIT</th>
              <th style={{ width: COLS.email }}>Email</th>
              <th style={{ width: COLS.localidad }}>Localidad</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={8} className="text-center">No hay transportes.</td></tr>
            ) : rows.map((t) => (
              <tr key={t._id}>
                <td style={{ width: COLS.acciones, whiteSpace: "nowrap" }}>
                  <div style={{ display: "flex", gap: 8, flexWrap: "nowrap", justifyContent: "center" }}>
                    <button className="btn btn-primary" onClick={() => modificaTransporte(t._id)}>
                      <i className="fa fa-pencil-square-o" aria-hidden="true" />
                    </button>
                    <button className="btn btn-danger" onClick={() => eliminarTransporte(t._id)}>
                      <i className="fa fa-trash-o" aria-hidden="true" />
                    </button>
                  </div>
                </td>
                <td style={{ width: COLS.nro }}>{t.codtra}</td>
                <td style={{ width: COLS.transporte, ...cellTruncate }}>{t.transporte}</td>
                <td style={{ width: COLS.domicilio, ...cellTruncate }}>{t.domicilio}</td>
                <td style={{ width: COLS.telefono }}>{t.telefono}</td>
                <td style={{ width: COLS.cuit }}>{t.cuit}</td>
                <td style={{ width: COLS.email, ...cellTruncate }}>{t.email}</td>
                <td style={{ width: COLS.localidad, ...cellTruncate }}>
                  {typeof t.localidad === "object" ? (t.localidad?.localidad || "-") : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <ModalTransporte show={show} handleClose={handleClose} transporte={transporte} />
    </div>
  );
};

export default TableTransportes;
